import { useStorage as useStorageVueUse } from '@vueuse/core'
import type { PiniaPluginContext } from 'pinia'
import type { CheckoutDeliveryModelV2 } from '@/models/checkout-delivery-model-v2'

export const deliveryPiniaPlugin = async (context: PiniaPluginContext) => {
  if (process.client && context.store.$id === 'delivery') {
    const DEFAULT_DELIVERY: CheckoutDeliveryModelV2 = {
      address: null,
      deliveryType: null,
      deliveryPeriod: undefined,
    }
    const deliveryLocalStorage = useStorageVueUse<CheckoutDeliveryModelV2>('delivery-storage', DEFAULT_DELIVERY)
    if (deliveryLocalStorage.value && deliveryLocalStorage.value.deliveryType)
      context.store.$state.deliveryData = deliveryLocalStorage.value

    context.store.$subscribe(() => deliveryLocalStorage.value = context.store.$state.deliveryData)
  }
}
